import onReady from 'site/on-ready';

const showErrors = (form, errors) => {
  form.querySelectorAll('.form-group.has-error').forEach((group) => {
    group.classList.remove('has-error');
    group.querySelectorAll('.js-error').forEach((el) => el.remove());
  });
  Object.entries(errors).forEach(([field, messages]) => {
    const group = form.querySelector(`#feedback_${field}`)?.closest('.form-group');
    if (!group) return;
    group.classList.add('has-error');
    const message = document.createElement('p');
    message.className = 'error-block js-error';
    message.textContent = messages[0];
    group.appendChild(message);
  });
};

// Hydrates the logged-in email prefill and account selector from the server.
// The page itself is static; this is the only request-time data, fetched after
// load. Anonymous visitors get empty values and keep the plain form.
const hydrateContext = async (form) => {
  let context;
  try {
    const response = await fetch('/contact_context');
    if (!response.ok) return;
    context = await response.json();
  } catch {
    return;
  }

  if (context.email) {
    const email = form.querySelector('#feedback_email');
    if (email && !email.value) email.value = context.email;
  }

  const accounts = context.accounts || [];
  if (accounts.length === 0) return;

  const select = form.querySelector('#feedback_account_id');
  const group = document.querySelector('#feedback-account');
  if (!select || !group) return;

  accounts.forEach(([label, id]) => {
    const option = document.createElement('option');
    option.value = id;
    option.textContent = label;
    select.appendChild(option);
  });
  group.hidden = false;
};

// Submits the contact form via fetch and renders the result client-side. The
// form carries no CSRF token; the create action skips forgery protection.
//
// Both elements ship in the same partial, so a missing one is a broken
// template, not a state to handle: take the plain form post rather than attach
// a submit handler that cannot report what it did.
export const ready = () => {
  const form = document.querySelector('#feedback-form');
  const sent = document.querySelector('#feedback-sent');
  if (!form || !sent) return;

  hydrateContext(form);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    let response;
    try {
      response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form)
      });
    } catch {
      // The request never landed, so leave the form in place for a retry. Only
      // the send is guarded: once it succeeds the message is gone, and treating
      // a later failure as retryable would ask for a second one.
      return;
    }

    if (response.ok) {
      sent.hidden = false;
      form.remove();
    } else if (response.status === 422) {
      const { errors } = await response.json();
      showErrors(form, errors);
    }
  });
};

onReady(ready);
